import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Table from '~/components/Table';
import { theme } from '~/styles/theme';
import EmptyPage from '~/pages/EmptyPage';
import * as S from './styles';
import * as Utils from './utils';

export default function Stats({
  className,
  statsData,
  isFetching,
  teamStatsFailed,
}) {
  const { t } = useTranslation();
  const {
    selectedMatch: { data: selectedMatch },
  } = useSelector(state => state.matches);

  const columns = React.useMemo(
    () => [
      {
        Header: () =>
          selectedMatch && selectedMatch.homeTeam ? (
            <img src={selectedMatch.homeTeam.shieldImageUrl} alt="" />
          ) : null,
        accessor: 'homeTeamValue',
      },
      {
        Header: t('globalStats'),
        accessor: stat => t(stat.statName),
      },
      {
        Header: () =>
          selectedMatch && selectedMatch.awayTeam ? (
            <img src={selectedMatch.awayTeam.shieldImageUrl} alt="" />
          ) : null,
        accessor: 'awayTeamValue',
      },
    ],
    [selectedMatch, t]
  );

  return (
    <S.StatsContainer className={className}>
      {teamStatsFailed && <EmptyPage />}
      {!teamStatsFailed && (
        <>
          {selectedMatch && selectedMatch.venue && (
            <S.StatsVenue>
              {selectedMatch.homeTeam && (
                <div>
                  <p>{t('foundationYear')}</p>
                  <p>({t('localClub')})</p>
                  <p className="bold">
                    {selectedMatch.homeTeam.yearFoundation
                      ? selectedMatch.homeTeam.yearFoundation
                      : '----'}
                  </p>
                </div>
              )}
              <div>
                <img
                  // matches/{id} debe traer dibujo del estadio REVISAR
                  src={
                    selectedMatch.venue.image
                      ? selectedMatch.venue.image
                      : 'https://assets.laliga.com/assets/2019/06/17/xlarge/f020571f7c260516dfab3b9dc5df6348.png'
                  }
                  alt=""
                />
              </div>
              <div>
                <p>{t('stadium')}</p>
                <p className="bold">{selectedMatch.venue.name}</p>
              </div>
            </S.StatsVenue>
          )}
          <S.StatsTable>
            <Table
              columns={columns}
              data={Utils.getOrderedData(statsData)}
              styleOptions={{
                backgroundColor: 'transparent',
                primaryColor: theme.dark5,
                secondaryColor: theme.dark4,
                textColor: theme.white,
                fullWidth: true,
              }}
              isFetching={isFetching}
              placeholderNumElements={15}
            />
          </S.StatsTable>
        </>
      )}
    </S.StatsContainer>
  );
}

Stats.propTypes = {
  className: PropTypes.string,
  statsData: PropTypes.array,
  isFetching: PropTypes.bool,
  teamStatsFailed: PropTypes.bool,
};

Stats.defaultProps = {
  className: null,
  statsData: [],
  isFetching: false,
  teamStatsFailed: false,
};
